export default __webpack_public_path__ + "968597eb0f2dec1e02a864863e7771f7.png";